import { InspectionTemplateItemModel } from 'components/dataProviders/withRequiredInspectionTemplate/types';
import { Permission } from 'shared/domain/permissions/types';

export interface TemplateListError {
  templateErrorType: string;
  helperText: string;
}

type ClickHandler = (item: InspectionTemplateItemModel) => void;

export interface TemplateListPresentationalProps {
  templates: InspectionTemplateItemModel[];
  activeId: string | undefined;
  handleClick: ClickHandler;
  error: TemplateListError | undefined;
  loaded: boolean;
  canCreateTemplate: () => Permission;
  createTemplate: () => void;
  canEditTemplate: (template: InspectionTemplateItemModel) => Permission;
  editTemplate: (template: InspectionTemplateItemModel) => void;
  canRemoveTemplate: () => Permission;
  removeTemplate: (templateId: string, templateSummary: string) => void;
  archiveTemplate: (templateId: string) => Promise<void>;
  restoreTemplate: (templateId: string) => Promise<void>;
  setCanScroll: (param: boolean) => void;
  searchChange: (phrase: string) => void;
  searchClear: () => void;
  searchPhrase: string;
  startInspection: (template: InspectionTemplateItemModel) => void;
  canStartInspection: (
    template: InspectionTemplateItemModel
  ) => Permission;
  showList: boolean;
}

export enum TemplateListErrorText {
  notFound = 'error_template_not_found',
  other = 'error_template_other',
  noTemplates = 'error_template_no_templates',
  noFilteredTemplates = 'list_search_empty_title',
}
